<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row mt-0">
      <div class="col-sm-12 custom-form-main-label" v-if="shiftId == 0">
        {{ $store.translate('add_shift')}}
      </div>
    </div>
    <div class="row mt-0" v-if="shiftId != -1">
      <div class="col-sm-12 custom-form-main-label">
        {{ $store.translate('manage_shift')}}
      </div>
    </div>
    <div class="row">
      <div class="col-12 p-0">
        <form id="createShiftForm" name="createShiftForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{ $store.translate('shift_name')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input required v-model="shifttname" type="text" id="txtshifttname" v-bind:placeholder="$store.translate('shift_name')" maxlength="200" name="shifttname" class="form-control" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('shift_type')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <select required class="form-control" v-bind:id="'select_assigned_shittype_' +  getId()">
                <option value="" style="">{{ $store.translate('select_shifttype')}}</option>
                <option v-for="type in shiftTypes" v-bind:value="type.shifttypeid">
                  {{ type.shifttypename }}
                </option>
              </select>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('start_time')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input required v-model="starttime" type="text" id="txtstarttime" v-bind:placeholder="$t('start_time')" maxlength="50" name="starttime" class="form-control" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('end_time')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input required v-model="endtime" type="text" id="txtendtime" v-bind:placeholder="$t('end_time')" maxlength="50" name="endtime" class="form-control" />
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12">
              <button @click="createShift" type="submit" class="btn skin primary-button pull-right"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  let message = "";
  var placeholder = "";
  var shiftTypes = [];
  var isStartTimeValid = true;
  var isEndTimeValid = true;
  export default {
    name: "add-shift",
    components: {

    },
    props: {
      shiftId: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        message: "",
        shifttname: "",
        starttime: "",
        endtime: "",
        shiftTypes: [],
        placeholder,
        isStartTimeValid: true,
        isEndTimeValid:true,
      };
    },
    methods: {
      clearFields() {
        this.shifttname = '';
        $("#select_assigned_shittype_" + this.getId()).val('');
        $("#select_assigned_shittype_" + this.getId()).trigger('change');
        this.starttime = '';
        this.endtime = '';

      },
      getId() {
        return this._uid;
      },
      async loadShiftTypes() {
        try {
          var url = "/api/Admin/v1/ShiftTypes?";
          this.$http.get(url).then(async response => {
            this.shiftTypes = response.data;

            if (this.shiftTypes !== null && this.shiftTypes.length > 0) {
              this.shiftTypes = this.shiftTypes.sort(function (a, b) {
                var x = a.sortorder.toLowerCase();
                var y = b.sortorder.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            $('#select_assigned_shittype_' + this.getId()).select2();
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      },
      async createShift() {

        if (!$('#createShiftForm').valid())
          return false;
        this.isStartTimeValid = true;
        this.isEndTimeValid = true;
        var time = new RegExp('^(([0-1]?[0-9])|([2][0-3])):([0-5]?[0-9])(:([0-5]?[0-9]))?$');       
        if (time.test(this.starttime)===false) {
          this.isStartTimeValid = false;
          alert("Start time is not valid.");
        }
        if (time.test(this.endtime) === false) {
          this.isEndTimeValid = false;
          alert("End time is not valid.");
        }
        if (!this.isEndTimeValid || !this.isStartTimeValid) {
          return false;
        }

        var request = {
          SiteShiftId: this.shiftId, Name: this.shifttname, StartTime: this.starttime,
          EndTime: this.endtime, ShiftTypeId: $('#select_assigned_shittype_' + this.getId()).val()
        };

        try {
          var response = await this.$http.post(
            '/api/Admin/v1/SiteShifts',
            request
          ).then(async response => {
            this.clearFields();
            vm.$root.$emit('refreshview');
          });

        } catch (err) {
          alert(err);
        }
      },
      async getShift(shiftId) {
        try {
          this.$http.get(`/api/Admin/v1/SiteShifts/${shiftId}`).then(async response => {
            var shift = response.data;
            this.shifttname = shift.Name;
            this.starttime = shift.StartTime;
            this.endtime = shift.EndTime;

            if (shift.ShiftTypeId > 0) {
              $("#select_assigned_shittype_" + this.getId()).val(shift.ShiftTypeId);
              $("#select_assigned_shittype_" + this.getId()).trigger('change');
            } else {
              $("#select_assigned_shittype_" + this.getId()).val(-1);
              $("#select_assigned_shittype_" + this.getId()).trigger('change');
            }
          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      shiftId: function (newVal, oldVal) {
        if (newVal > 0) {
          this.getShift(newVal);
        } else {
          this.projectname = '';
          this.description = '';
        }
      }
    },
    mounted() {
      _componentValidation('#createShiftForm');
      if (this.shiftId > 0) {
        this.getShift(this.shiftId);
      }

      this.placeholder = this.$t('project_description');
      this.loadShiftTypes();
    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/shift/add-shift.vue